import React, {useEffect, useState} from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import Card from '@mui/material/Card';
import Moment from 'react-moment';
import {Drawer} from '@mui/material';
import {acquisitionActivityLogService} from '../../../services/TaskPoolServices';

const STATE_LABELS = {
  forwarded_to_curator: {description: 'forwarded to curator', chip: 'Curator'},
};

const getStateDescription = state => STATE_LABELS[state]?.description || state;
const getStateChipLabel = state => STATE_LABELS[state]?.chip || state;

export default function AcquisitionAuditTrails(props) {
  const {acquisitionId, openLog, handleLogClose} = props;
  const [task, setTask] = useState([]);

  useEffect(() => {
    getTaskPoolActivityLog();
  }, []);

  const getTaskPoolActivityLog = () => {
    acquisitionActivityLogService('get', acquisitionId).then(res => {
      setTask(res?.data);
    })
  }
  return (
    <Drawer
      open={openLog}
      anchor="right"
      onClose={handleLogClose}
      BackdropProps={{style: {backgroundColor: 'rgba(0, 0, 0, 0)'}}}
      sx={{
        '& .MuiDrawer-paper': {
          boxSizing: 'border-box',
          width: '30%',
          height: 'calc(100% - 87px)',
          top: 87,
          backgroundColor: '#F4F7FC',
          borderTopLeftRadius: 12,
          borderBottomLeftRadius: 12,
        },
      }}
    >
      {/* Header */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        sx={{
          px: 3,
          py: 2,
          borderBottom: "1px solid #E5E7EB",
          background: "#fff",
        }}
      >
        <Typography
          sx={{
            fontSize: 20,
            fontWeight: 600,
            color: "#1E293B",
          }}
        >
          Audit Trail
        </Typography>
        <IconButton onClick={handleLogClose}>
          <CloseRoundedIcon/>
        </IconButton>
      </Box>

      {/* Body */}
      <Box
        sx={{
          p: 2,
          overflowY: "auto",
          height: "100%",
        }}
      >
        {task && task.length > 0 ? (
          task?.map((val, index) => (
            <Card 
              key={index}
              elevation={2} 
              sx={{
                mb: 2,
                p: 2,
                borderRadius: 3,
                borderLeft: "5px solid #616B88",
              }}
            >
              <Typography
                sx={{
                  fontSize: 15,
                  fontWeight: 600,
                  color: "#1F2937",
                  mb: 1,
                }}
              >
                {val?.message || <>Acquisition {getStateDescription(val?.state)} by <strong>{val?.by_name}</strong></>}
              </Typography>

              <Box
                sx={{
                  display: "inline-block",
                  px: 1.5,
                  py: 0.5,
                  borderRadius: "20px",
                  backgroundColor:
                    val?.state === 'forwarded_to_curator'
                      ? "#E8F5E9"
                      : "#E3F2FD",
                  color:
                    val?.state === 'forwarded_to_curator'
                      ? "#2E7D32"
                      : "#1565C0",
                  fontSize: 13,
                  fontWeight: 600,
                  mb: 1.5,
                  textTransform: 'capitalize',
                }}
              >
                {val?.state_label || getStateChipLabel(val?.state)}
              </Box>

              {val?.description && (
                <Typography 
                  sx={{ 
                    fontSize: 14, 
                    color: '#555555', 
                    mb: 1.5 
                  }}
                >
                  {val?.description}
                </Typography>
              )}

              <Typography
                sx={{
                  fontSize: 13,
                  color: "#6B7280",
                }}
              >
                <Moment format="MMMM Do YYYY, h:mm:ss a">
                  {val?.timestamp}
                </Moment>
              </Typography>
            </Card>
          ))
        ) : (
          <Box
            sx={{
              height: "80%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography
              sx={{
                color: "#9CA3AF",
                fontSize: 15,
              }}
            >
              No activity logs available
            </Typography>
          </Box>
        )}
      </Box>
    </Drawer>
  );
}